import * as React from 'react'
import styled from 'styled-components'
import { Container, Row, config } from 'react-awesome-styled-grid'
import { P } from '../shared/typography'
import { colors } from '@components/shared/colors'
import ReviewSlider from '@components/ReviewSlider'

const slides = [
  {
    quote:
      'Life-changing. This app is so thoroughly consensual that I’m able to finally relax and enjoy myself.',
    subText: '10.24.21',
    audioUrl: '',
    name: 'Maya'
  },
  {
    quote:
      'With so many different stories, themes, and voices to choose from, I feel so free and invited to explore my sexuality in the best way.',
    subText: '09.18.21',
    audioUrl: '',
    name: 'Whitney'
  },
  {
    quote:
      'As a woman in the trauma healing process, this app helped me feel so amazing. I have less feelings of shame and guilt because of Dipsea.',
    subText: '11.04.21',
    audioUrl: '',
    name: 'Lizzie'
  },
  {
    quote: `I love how varied and queer-friendly this app is. The characters feel like real, interesting people and that’s what makes them so compelling.`,
    subText: '08.25.21',
    audioUrl: '',
    name: 'Jahnavi'
  },
  {
    quote: `These stories allow an escape into the body—a time to focus on yourself and re-energize. It truly is a form of healing and therapy.`,
    subText: '1.19.21',
    audioUrl: '',
    name: 'Aka'
  },
  {
    quote: `Sensual and super sexy stories created by humans that ACTUALLY explore the inner workings of the human psyche. Guaranteed to get you off and put you to sleep.`,
    subText: '12.15.20',
    audioUrl: '',
    name: 'Leisha'
  }
]

export default function UserQuotesSlideCarousel (props: { hasMarginTop?: boolean }): React.ReactNode {
  return (
    <Container>
      <Row>
        <ReviewSectionTitle hasMarginTop={!!props.hasMarginTop}>
        Reviews
        </ReviewSectionTitle>
        <ReviewSlider
          slides={slides}
        />
      </Row>
    </Container>
  )
}

const ReviewSectionTitle = styled(P)<any>`
  text-align: center;
  width: 100%;
  max-width: 270px;
  margin: ${(props: any): string => props.hasMarginTop ? '30px auto 42px' : '0 auto 42px'};
  text-transform: uppercase;
  font-size: 14px;
  line-height: 1.21em;
  text-align: center;
  letter-spacing: 0.03em;
  color: ${colors.sand};
  white-space: pre;
  ${(props: any): any => config(props).media.md`
    max-width: unset;
    white-space: unset;
    margin-top: ${props.hasMarginTop ? '110px' : '0'};
  `}
  ${(props: any): any => config(props).media.lg`
    margin-top: ${props.hasMarginTop ? '169px' : '0'};
  `}
`
